import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import 'dayjs/locale/de';
import { isTabletOrMobile } from '../../utils';

const LocalizedDatePicker = observer(
  ({
    onClose,
    initDate,
  }: {
    onClose: (value: Date | null) => void;
    initDate: Date | undefined;
  }) => {
    const [value, setValue] = useState<Dayjs | null>(
      dayjs(initDate) || dayjs(),
    );

    const handleChange = (newValue: Dayjs | null) => {
      setValue(newValue);
      onClose(dayjs(newValue).toDate());
    };

    const checkPhone = isTabletOrMobile();

    return (
      <Box>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          {checkPhone ? (
            <MobileDateTimePicker
              format="DD.MM.YYYY HH:mm"
              ampm={false}
              disablePast
              value={value}
              onChange={handleChange}
            />
          ) : (
            <DateTimePicker
              format="DD.MM.YYYY HH:mm"
              ampm={false}
              disablePast
              value={value}
              onChange={handleChange}
            />
          )}
        </LocalizationProvider>
      </Box>
    );
  },
);

export default LocalizedDatePicker;
